import React from 'react';
import style from './componentCss/buttom.module.css';
import { Link } from 'react-router-dom';

const Button = ({
    type = 'button',
    href,
    fontSize = '13px',
    fontWeight = 300,
    backgroundColor = 'rgb(0, 100, 224)',
    width,
    height,
    fontcolor = 'white',
    handleClick,
    children,
}) => {
    const customStyle = {
        fontWeight,
        backgroundColor,
        width,
        height,
        color: fontcolor,
        fontSize,
        border: 'none',
        textDecoration: 'none',
        display: 'inline-block',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '10px 15px',
        borderRadius: '8px',
        cursor: (backgroundColor === 'gray' || backgroundColor === '#888') ? 'not-allowed' : 'pointer',
        pointerEvents: (backgroundColor === 'gray' || backgroundColor === '#888') ? 'none' : 'auto',
        opacity: (backgroundColor === 'gray' || backgroundColor === '#888') ? 0.6 : 1,
    };

    return href ? (
        <Link to={href} className={style.button} style={customStyle} onClick={handleClick}>
            {children}
        </Link>
    ) : (
        <button type={type} className={style.button} style={customStyle} onClick={handleClick}>
            {children}
        </button>
    );
};

export default Button;
